import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'principal-residence-form',
    templateUrl: './principal-residence-form.component.html',
    styleUrls: ['./principal-residence-form.component.scss'],
    standalone: false
})
export class PrincipalResidenceFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options = [
    {
      label: 'Propriétaire',
      value: 'OWNER',
      suffix: 'A',
      svg: 'owner.svg',
    },
    {
      label: 'Locataire',
      value: 'TENANT',
      suffix: 'B',
      svg: 'tentant.svg',
    },
    {
      label: 'Logé à titre gracieux',
      value: 'HOSTED',
      suffix: 'C',
      svg: 'hosted.svg',
    },
  ];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,

    protected injector: Injector,
  ) {
    super(formConstructor, injector);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    // Le moyen de détention est pré-sélectionné (« Propriétaire », cf. le builder)
    // mais ce n'est qu'une valeur de formulaire : sans markAsDirty, un client qui
    // valide sans cliquer sur une carte laisse le form pristine et
    // EntityService.submitPledge passe au step suivant SANS rien enregistrer.
    // `addressSituation` restait alors null sur l'owner → moyen de détention vide
    // dans les documents et NPE côté back sur AddressSituationEnum.getLabel().
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
